export const NEWS_LIST = [
    {
        id: 1,
        date: '22 ديسمبر 2025',
        title:
            'الهيئة العامة للاستثمار والمناطق الحرة تشارك في المؤتمر السنوي الرابع «غذاء مصر… صناعة تنافسية ومستقبل مستدام»',
        description:
            'أكد السيد/ حسام هيبة أن تهيئة مناخ استثماري جاذب تُعد ركيزة أساسية لدعم وتطوير قطاع الصناعات الغذائية، وتعزيز قدرته على المنافسة محليًا وإقليميًا ودوليًا بما يحقق أهداف التنمية المستدامة.',
        image: 'assets/media/news/new1.jpg',
    },
    {
        id: 2,
        date: '22 ديسمبر 2025',
        title:
            'رئيس هيئة الاستثمار يتفقد مشروع «نايا ويلنس نايل سورناجا» المملوك لهيئة الاستثمار كنموذج ناجح للشراكة بين الدولة والقطاع الخاص في مجال السياحة العلاجية',
        description:
            '* رئيس هيئة الاستثمار يتفقد أول منطقة استثمارية طبية متكاملة مملوكة للهيئة. * هيئة الاستثمار ومجموعة مكسيم للاستثمار يقودان تطوير منطقة «نايا» الاستثمارية لتعزيز مكانة مصر في السياحة العلاجية.',
        image: 'assets/media/news/new2.jpg',
    },
    {
        id: 3,
        date: '17 ديسمبر 2025',
        title:
            'الهيئة العامة للاستثمار والمناطق الحرة تستضيف مؤتمرًا حول التحول الصناعي نحو اقتصاد منخفض الكربون في ظل آلية تعديل حدود الكربون (CBAM)',
        description: 'التحول الصناعي نحو اقتصاد منخفض الكربون',
        image: 'assets/media/news/new3.jpg',
    },
    {
        id: 4,
        date: '16 ديسمبر 2025',
        title:
            'رئيس هيئة الاستثمار يشارك في مؤتمر التكنولوجيا العقارية والمدن الذكية المستدامة “NeoGen”',
        description:
            'هيبة: انخفاض ملحوظ في عدد شكاوى الشركات بفضل تحسين بيئة الاستثمار رئيس هيئة الاستثمار: تطوير التشريعات لتواكب النمو السريع لقطاع PropTech',
        image: 'assets/media/news/new4.jpg',
    },
    {
        id: 5,
        date: '15 ديسمبر 2025',
        title:
            'الهيئة العامة للاستثمار تبحث التعاون مع IT Park Uzbekistan لدعم الشركات التكنولوجية وتعزيز الاستثمارات المتبادلة',
        description:
            'استقبلت الهيئة العامة للاستثمار والمناطق الحرة وفدًا رفيع المستوى من منطقة تكنولوجيا المعلومات IT Park Uzbekistan',
        image: 'assets/media/news/new5.jpg',
    },
    {
        id: 6,
        date: '15 ديسمبر 2025',
        title:
            'رئيس الهيئة العامة للاستثمار يشارك في المنتدى الاستثماري المصري القطري بالقاهرة',
        description:
            'هيبة: المنتدى الاستثماري المصري القطري يؤكد عمق الشراكة الاقتصادية بين البلدين الهيئة العامة للاستثمار: المنتدى المصري القطري يعزز الشراكة الاقتصادية ويفتح آفاقًا جديدة للاستثمار',
        image: 'assets/media/news/new6.jpg',
    },
    {
        id: 7,
        date: '15 ديسمبر 2025',
        title:
            'الهيئة العامة للاستثمار تشهد توقيع عقد بين السويدي للتنمية الصناعية واستثمار بولندي يُعد الأول من نوعه في قطاع الأغذية',
        description:
            'أعلنت شركة السويدي للتنمية الصناعية عن توقيع عقد بيع أرض صناعية مع شركة Fruitful البولندية',
        image: 'assets/media/news/new7.jpg',
    },
    {
        id: 8,
        date: '14 ديسمبر 2025',
        title:
            'الهيئة العامة للاستثمار والمناطق الحرة وبنك الإمارات دبي الوطني يوقعان مذكرة تفاهم لتعزيز الاستثمار',
        description:
            'الهيئة العامة للاستثمار والمناطق الحرة وبنك الإمارات دبي الوطني يوقعان مذكرة تفاهم لتعزيز الاستثمار وترويج الفرص الاستثمارية في مصر',
        image: 'assets/media/news/new8.jpg',
    },
    {
        id: 9,
        date: '11 ديسمبر 2025',
        title:
            'رئيس الهيئة العامة للاستثمار والمناطق الحرة يشارك في وضع حجر الأساس لقاعدة مصنع ديلي إيجيبت للأدوات المكتبية',
        description:
            'رئيس الهيئة العامة للاستثمار والمناطق الحرة يشارك في وضع حجر الأساس لقاعدة مصنع "ديلي إيجيبت" للأدوات المكتبية بمدينة العاشر من رمضان. * هيبة: مشروع صناعي جديد باستثمارات تقدر بنحو ٢٠٠ مليون دولار أميريكي',
        image: 'assets/media/news/new9.jpg',
    },
    {
        id: 10,
        date: '11 ديسمبر 2025',
        title:
            'رئيس هيئة الاستثمار يشارك في احتفالية شركة قرة انرجي،25 عامًا من العمل في مجالات الطاقة والمرافق والبنية التحتية',
        description:
            'شارك السيد/ حسام هيبة، الرئيس التنفيذي للهيئة العامة للاستثمار والمناطق الحرة، في الاحتفال الذي نظمته شركة قرة انرجي بمناسبة مرور 25 عامًا على تأسيسها',
        image: 'assets/media/news/new.jpg',
    },
];
